function generateBoletiaURL(eventSubdomain) {
  return `https://${eventSubdomain}.boletia.com`;
}

export default generateBoletiaURL;
